/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import '@xengage/gw-platform-translations';
import _ from 'lodash';
import { MLScriptComponent } from 'ml-components-common-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { MLBillingUtil } from 'ml-portals-util-react';
import messages from './MLPaymentScheduleComponent.messages';
import metadata from './MLPaymentScheduleComponent.metadata.json5';
import styles from './MLPaymentScheduleComponent.module.scss';

import { IntlContext } from '@jutro/legacy/locale';

// ML: MLPaymentDetailsMethodDirectiveCtrl.js, ml-payment-details-method.html

function MLPaymentScheduleComponent(props) {
    const translator = useTranslator();
    const { authHeader, authUserData } = useAuthentication();

    const {
        id,
        onValidate,
        showValidationErrors,
        paymentDetails,
        isEndorsement,
        offeredQuotes,
        chosenQuote,
        termType,
        gpaMode,
        selectPaymentPlan,
        isPaymentScriptChecked,
        periodStartDate,
        selectPreferredPaymentMethodInd,
        isModernProduct,
        qnbMode,
        updateWizardData,
        submissionVM
    } = props;

    const { refreshData } = useDataRefresh();
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);
    const [scriptML, updateScriptML] = useState([]);
    const [isChecked, setIsChecked] = useState(false);
    const [showScriptCheckbox, setShowScriptCheckbox] = useState(false);
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isUMB_NP = isPersonalUmbrella && isModernProduct;


    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, onValidate, isComponentValid]);

    const intl = useContext(IntlContext);

    const {
        MLAnnuallyPayPlanPublicId,
        MLMortgageePayPlanPublicId,
        MLMonthlyPayPlanPublicId,
        MLTwicePerMonthPayPlanPublicId,
        MLMonthlyAnnualResponsivePlanPublicId,
        MLMonthlySemiAnnualResponsivePlanPublicId,
        MLTwoPayAnnualPlanPublicId,
        MLTwoPaySemiAnnualPlanPublicId,
        MLFourPayAnnualPlanPublicId,
        FMPAMonthlyAnnualResponsivePlanPublicId,
        FMPAMonthlySemiAnnualResponsivePlanPublicId,
        NPTwoPayAnnualAutoPay
    } = appConfig.mlPaymentPlan;

    const {
        MLUserTypes
    } = appConfig

    const {
        getFullPayLabelForTermType,
        getAccountPaymentMethods,
        getRatingPaymentMethods,
        getFullPayPlanPeriodFromQuotes,
        getInstallmentsPlanPeriodFromQuotes
    } = MLBillingUtil();

    const accountPaymentMethods = getAccountPaymentMethods();
    const ratingPaymentMethods = getRatingPaymentMethods();

    let isAgentScripts= false;
    if (authUserData) {
        isAgentScripts = authUserData.userType === MLUserTypes.GCS_SALES || authUserData.userType === MLUserTypes.GCS_SERVICING|| authUserData.userType === MLUserTypes.MET_GA;
    }

    const updateCheckboxValue = (value) => {
        setIsChecked(value);
        isPaymentScriptChecked(value);
    };

    const showCheckbox = () => {
        return showScriptCheckbox;
    };

    const showScript = () => {
        return isEndorsement && isAgentScripts && gpaMode
    }

    const getRatingPaymentMethodCode = () => {
        return paymentDetails.ratingPaymentMethod_ML.value ? paymentDetails.ratingPaymentMethod_ML.value.code : '';
    };

    const getFormatCurrency = (value) => {
        let formattedAmount = '';
        if (value) {
            const { amount, currency } = value;
            if (!_.isUndefined(amount) && currency) {
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency
                    }
                );
            }
        }
        return formattedAmount;
    };

    const getPolicyTerm = () => {
        if (termType === 'Annual') {
            return translator(messages.Year);
        }
        if (termType === 'HalfYear') {
            return translator(messages.HalfYear);
        }
        return '';
    };

    const getFullPayPlanPremium = (ratingPaymentMethod) => {
        if (isEndorsement) {
            if (paymentDetails.paymentPlans_ML) {
                const paymentPlan = _.find(paymentDetails.paymentPlans_ML.value, { billingId: MLAnnuallyPayPlanPublicId });
                return paymentPlan ? paymentPlan.downPayment : null;
            }
        }
        const quoteData = getFullPayPlanPeriodFromQuotes(offeredQuotes, ratingPaymentMethod, chosenQuote.value);
        if (quoteData) {
            let paymentPlan = _.find(quoteData.paymentPlans_ML, { billingId: MLAnnuallyPayPlanPublicId });
            if (!paymentPlan) {
                paymentPlan = _.find(quoteData.paymentPlans_ML, { billingId: MLMortgageePayPlanPublicId });
                return paymentPlan ? paymentPlan.installment : null;
            }
            return paymentPlan ? paymentPlan.total : null;
        }
        return null;
    };

    const getFullPayPlanPremiumSaving = (ratingPaymentMethod) => {
        let savedAmount = {
            amount: 0,
            currency: 'usd'
        };
        const quoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, ratingPaymentMethod, chosenQuote.value);
        if (quoteData) {
            const maxAmount = Math.max(...quoteData.paymentPlans_ML.map((paymentPlan) => { return paymentPlan.total ? paymentPlan.total.amount : 0; }));
            savedAmount = Object.assign({}, getFullPayPlanPremium(ratingPaymentMethod));
            savedAmount.amount = maxAmount - savedAmount.amount;
        }
        return savedAmount;
    };

    const getPaymentDueToday = (ratingPaymentMethod, payPlanID) => {
        const defaultDueToday = { amount: 0, currency: 'usd' };
        if (paymentDetails.downPaymentOverride_ML && paymentDetails.downPaymentOverride_ML.value) {
            return defaultDueToday;
        }
        if (!payPlanID) {
            if (isEndorsement) {
                const paymentPlan = _.find(paymentDetails.paymentPlans_ML.value, { billingId: MLAnnuallyPayPlanPublicId });
                return paymentPlan ? paymentPlan.downPaymentPlusFees_ML : defaultDueToday;
            }
            const quoteData = getFullPayPlanPeriodFromQuotes(offeredQuotes, ratingPaymentMethod, chosenQuote.value);
            if (quoteData) {
                const paymentPlan = _.find(quoteData.paymentPlans_ML, { billingId: MLAnnuallyPayPlanPublicId });
                if (paymentPlan) {
                    if (paymentPlan.downPayment.amount > 0) {
                        return paymentPlan ? paymentPlan.downPaymentPlusFees_ML : defaultDueToday;
                    }
                    return paymentPlan ? paymentPlan.installmentPlusFees_ML : defaultDueToday;
                }
                return paymentPlan ? paymentPlan.installmentPlusFees_ML : defaultDueToday;
            }
        } else {
            if (isEndorsement) {
                if (paymentDetails.paymentPlans_ML) {
                    const paymentPlan = _.find(paymentDetails.paymentPlans_ML.value, { billingId: payPlanID });
                    return paymentPlan ? paymentPlan.installmentPlusFees_ML : defaultDueToday;
                }
            }
            const quoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, ratingPaymentMethod, chosenQuote.value);
            if (quoteData) {
                const paymentPlan = _.find(quoteData.paymentPlans_ML, { billingId: payPlanID });
                if (paymentPlan) {
                    if (paymentPlan.downPayment && paymentPlan.downPayment.amount > 0) {
                        return paymentPlan ? paymentPlan.downPaymentPlusFees_ML : defaultDueToday;
                    }
                    return paymentPlan ? paymentPlan.installmentPlusFees_ML : defaultDueToday;
                }
                return paymentPlan ? paymentPlan.installmentPlusFees_ML : defaultDueToday;
            }
        }

        return defaultDueToday;
    };

    const getFullPayPlanOptionName = () => {
        if (!isEndorsement) {
            return `${getFullPayLabelForTermType(termType)} (${getFormatCurrency(getFullPayPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code))}/${getPolicyTerm(termType)}) ${translator(messages.SaveX, { amount: getFormatCurrency(getFullPayPlanPremiumSaving(paymentDetails.ratingPaymentMethod_ML.value.code)) })}`;
        }
        return getFullPayLabelForTermType(termType);
    };

    const getInstallmentsPlanPremium = (ratingPaymentMethod, payPlanID) => {
        if (isEndorsement) {
            if (paymentDetails.paymentPlans_ML) {
                const paymentPlan = _.find(paymentDetails.paymentPlans_ML.value, { billingId: payPlanID });
                return paymentPlan ? paymentPlan.installment : null;
            }
        }

        const quoteData = getInstallmentsPlanPeriodFromQuotes(offeredQuotes, ratingPaymentMethod, chosenQuote.value);
        if (quoteData) {
            const paymentPlan = _.find(quoteData.paymentPlans_ML, { billingId: payPlanID });
            return paymentPlan ? paymentPlan.installment : null;
        }

        return null;
    };

    const getInstallmentPlanOptionName = (payPlanID, paymentMessageId, scheduleMessageId) => {
        if (!isEndorsement) {
            if (!scheduleMessageId) {
                return `${translator(paymentMessageId)} 
                    (${getFormatCurrency(getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, payPlanID))})`;
            }
            return `${translator(paymentMessageId)} 
                (${getFormatCurrency(getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, payPlanID))}/${translator(scheduleMessageId)})`;
        }
        return translator(paymentMessageId);
    };

    const getPaymentPlanSecondaryLabel = (payPlanID) => {
        if (paymentDetails.selectedPaymentPlan_ML.value === payPlanID && !isEndorsement) {
            const paymentDueAmount = payPlanID === MLAnnuallyPayPlanPublicId
                ? getPaymentDueToday(paymentDetails.ratingPaymentMethod_ML.value.code)
                : getPaymentDueToday(paymentDetails.ratingPaymentMethod_ML.value.code, payPlanID);

            return (
                <FormattedMessage
                    {...messages.PayPlanSecondaryLabel}
                    values={{
                        paymentDueMessage: <strong>{translator(messages.PaymentAmountDueTodayIs)}&nbsp;</strong>,
                        paymentDueAmount: <strong>{getFormatCurrency(paymentDueAmount)}</strong>,
                        taxMessage: paymentDueAmount && paymentDueAmount.amount !== 0 ? translator(messages.IncludesTaxesAndFees) : ''
                    }}
                />
            );
        }
        return '';
    };

    const getValidPaymentSchedules = () => {
        const schedules = [];
        if (getFullPayPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code)) {
            schedules.push({
                code: MLAnnuallyPayPlanPublicId,
                name: getFullPayPlanOptionName(),
                secondaryLabel: getPaymentPlanSecondaryLabel(MLAnnuallyPayPlanPublicId)
            });
        }
        if (getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, MLMonthlyPayPlanPublicId)) {
            schedules.push({
                code: MLMonthlyPayPlanPublicId,
                name: getInstallmentPlanOptionName(MLMonthlyPayPlanPublicId, messages.MonthlyPayment, messages.Monthly),
                secondaryLabel: getPaymentPlanSecondaryLabel(MLMonthlyPayPlanPublicId)
            });
        }
        if (!isModernProduct && getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, MLMonthlyAnnualResponsivePlanPublicId)) {
            schedules.push({
                code: MLMonthlyAnnualResponsivePlanPublicId,
                name: getInstallmentPlanOptionName(MLMonthlyAnnualResponsivePlanPublicId, messages.MonthlyPayment, messages.Monthly),
                secondaryLabel: getPaymentPlanSecondaryLabel(MLMonthlyAnnualResponsivePlanPublicId)
            });
        }
        if (!isModernProduct && getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, MLMonthlySemiAnnualResponsivePlanPublicId)) {
            schedules.push({
                code: MLMonthlySemiAnnualResponsivePlanPublicId,
                name: getInstallmentPlanOptionName(MLMonthlySemiAnnualResponsivePlanPublicId, messages.MonthlyPayment, messages.Monthly),
                secondaryLabel: getPaymentPlanSecondaryLabel(MLMonthlySemiAnnualResponsivePlanPublicId)
            });
        }
        if (isModernProduct && getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, FMPAMonthlyAnnualResponsivePlanPublicId)) {
            schedules.push({
                code: FMPAMonthlyAnnualResponsivePlanPublicId,
                name: getInstallmentPlanOptionName(FMPAMonthlyAnnualResponsivePlanPublicId, messages.MonthlyPayment, messages.Monthly),
                secondaryLabel: getPaymentPlanSecondaryLabel(FMPAMonthlyAnnualResponsivePlanPublicId)
            });
        }
        if (isModernProduct && getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, FMPAMonthlySemiAnnualResponsivePlanPublicId)) {
            schedules.push({
                code: FMPAMonthlySemiAnnualResponsivePlanPublicId,
                name: getInstallmentPlanOptionName(FMPAMonthlySemiAnnualResponsivePlanPublicId, messages.MonthlyPayment, messages.Monthly),
                secondaryLabel: getPaymentPlanSecondaryLabel(FMPAMonthlySemiAnnualResponsivePlanPublicId)
            });
        }
        if (isModernProduct && getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, NPTwoPayAnnualAutoPay)) {
            schedules.push({
                code: NPTwoPayAnnualAutoPay,
                name: getInstallmentPlanOptionName(NPTwoPayAnnualAutoPay, messages.TwoPayAnnualAutopay),
                secondaryLabel: getPaymentPlanSecondaryLabel(NPTwoPayAnnualAutoPay)
            });
        }
        if (!isModernProduct && getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, MLTwicePerMonthPayPlanPublicId)) {
            schedules.push({
                code: MLTwicePerMonthPayPlanPublicId,
                name: getInstallmentPlanOptionName(MLTwicePerMonthPayPlanPublicId, messages.TwicePerMonth, messages.BiMonthly),
                secondaryLabel: getPaymentPlanSecondaryLabel(MLTwicePerMonthPayPlanPublicId)
            });
        }
        if (getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, MLTwoPayAnnualPlanPublicId)) {
            schedules.push({
                code: MLTwoPayAnnualPlanPublicId,
                name: getInstallmentPlanOptionName(MLTwoPayAnnualPlanPublicId, messages.TwoPay),
                secondaryLabel: getPaymentPlanSecondaryLabel(MLTwoPayAnnualPlanPublicId)
            });
        }
        if (getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, MLTwoPaySemiAnnualPlanPublicId)) {
            schedules.push({
                code: MLTwoPaySemiAnnualPlanPublicId,
                name: getInstallmentPlanOptionName(MLTwoPaySemiAnnualPlanPublicId, messages.TwoPay),
                secondaryLabel: getPaymentPlanSecondaryLabel(MLTwoPaySemiAnnualPlanPublicId)
            });
        }
        if (!isUMB_NP && getInstallmentsPlanPremium(paymentDetails.ratingPaymentMethod_ML.value.code, MLFourPayAnnualPlanPublicId)) {
            schedules.push({
                code: MLFourPayAnnualPlanPublicId,
                name: getInstallmentPlanOptionName(MLFourPayAnnualPlanPublicId, messages.FourPay),
                secondaryLabel: getPaymentPlanSecondaryLabel(MLFourPayAnnualPlanPublicId)
            });
        }

        return schedules;
    };

    const getAnnualPaymentScript = () => {
        const lines = ['You will receive a Payment Authorization Form that you will be required to sign and return to us in order to remain on Auto pay.',
            'Once complete, the next payment will be taken out based on your billing statement unless you make any changes to this agreement. Do you accept these terms?'];
        updateScriptML(lines);
    };

    const getMonthlyTwiceMonthlyScript = () => {
        const lines = ['You will receive a Payment Authorization Form that you will be required to sign and return to us in order to begin your recurring payments.',
            'Do you accept these terms?'];
        updateScriptML(lines);
    };

    const getPaymentFrequencyScript = () => {
        const lines = ['You will receive a Payment Authorization Form that you will be required to sign and return to us in order to begin your automatic payments.',
            'Do you accept these terms?'];
        updateScriptML(lines);
    };

    const onPaymentScheduleOptionChange = (value) => {
        selectPaymentPlan(value);
      if (qnbMode) {
        _.set(submissionVM, "bindData.paymentDetails.selectedPaymentPlan_ML.value", value);
        updateWizardData(submissionVM);
      }
        setShowScriptCheckbox(false);
        updateCheckboxValue(false);  
        if (paymentDetails?.paymentMethod?.value == "responsive") {
            paymentDetails.paymentDayOfMonth_ML.value = periodStartDate?.value?.day;
        }

        if (isModernProduct) {
            if ([MLAnnuallyPayPlanPublicId, MLTwoPayAnnualPlanPublicId].includes(value)) {
                _.set(paymentDetails, 'value.preferredPaymentMethodInd_Ext', true);
            } else {
                _.set(paymentDetails, 'value.preferredPaymentMethodInd_Ext', false);
            }
        }

        refreshData();

        if (isAgentScripts && (getRatingPaymentMethodCode() === ratingPaymentMethods.CREDIT_CARD || getRatingPaymentMethodCode() === ratingPaymentMethods.BANK_ACCOUNT)) {
            getPaymentFrequencyScript();
            setShowScriptCheckbox(true);
        }
    };

    const updatePreferredPaymentValue = (value) => {
        setpreferredPaymentMethodSelected(value);
        _.set(paymentDetails, 'value.preferredPaymentMethodInd_Ext', value);
    };

    useEffect(() => {
        const selectedPaymentPlanValue = paymentDetails.selectedPaymentPlan_ML.value;
        setShowScriptCheckbox(false);
        updateCheckboxValue(false);
        if (selectedPaymentPlanValue && isAgentScripts && gpaMode && isEndorsement && getRatingPaymentMethodCode() === ratingPaymentMethods.BANK_ACCOUNT) {
            if (selectedPaymentPlanValue === MLAnnuallyPayPlanPublicId) {
                getAnnualPaymentScript();
            }
            if (selectedPaymentPlanValue === MLMonthlyPayPlanPublicId || selectedPaymentPlanValue === MLTwicePerMonthPayPlanPublicId ) {
                getMonthlyTwiceMonthlyScript();
            }
        }
        if (selectedPaymentPlanValue && isAgentScripts && gpaMode && isEndorsement && (getRatingPaymentMethodCode() === ratingPaymentMethods.CREDIT_CARD ||
            getRatingPaymentMethodCode() === ratingPaymentMethods.BANK_ACCOUNT)) {
            getPaymentFrequencyScript();
            setShowScriptCheckbox(true);
        }
    }, []);

    const getValidDayOfMonths = () => {
        const days = [];
        for (let i = 1; i < 32; i += 1) {
            days.push({ code: i, name: i });
        }
        return days;
    };

    const onDayOfMonthChange = (value) => {
        paymentDetails.paymentDayOfMonth_ML.value = value;
        refreshData();
    };

    const onEmailNoticeChange = (value) => {
        paymentDetails.preferEmailNotice_ML.value = value;
        refreshData();
    }

    const showPaymentDayOfMonth = () => {
        return paymentDetails.selectedPaymentPlan_ML.value !== MLAnnuallyPayPlanPublicId
            && (getRatingPaymentMethodCode() === ratingPaymentMethods.BANK_ACCOUNT || getRatingPaymentMethodCode() === ratingPaymentMethods.CREDIT_CARD);
    };

    const showEmailReminder = () => {
        return paymentDetails.paymentMethod.value === (accountPaymentMethods.CREDIT_CARD || accountPaymentMethods.BANK_ACCOUNT);
    };

    const getEmailReminderText = () => {
        return gpaMode ? translator(messages.WouldCustomerLike)
            : translator(messages.WouldYouLike);
    };

    const isPreferredPaymentVisible = () => {
        const isPreferredScheduleSelected = [MLAnnuallyPayPlanPublicId, MLTwoPayAnnualPlanPublicId].includes(paymentDetails.selectedPaymentPlan_ML?.value);
        return isModernProduct && (gpaMode || qnbMode) && isPreferredScheduleSelected;
    };

    const getdayOfMonth = () => {
        if(paymentDetails.paymentMethod?.value == "responsive") {
            return periodStartDate?.value?.day; 
        } 
        if(!_.isUndefined(paymentDetails.paymentDayOfMonth_ML?.value)) {
            return paymentDetails.paymentDayOfMonth_ML.value ;
        } else {
            return periodStartDate?.value?.day;
        }
    };

    const resolvers = {
        resolveComponentMap: {
            mlScriptComponent: MLScriptComponent
        },
        resolveClassNameMap: styles
    };

    const overrides = {
        paymentScheduleOptions: {
            availableValues: getValidPaymentSchedules(),
            onValueChange: onPaymentScheduleOptionChange,
            className: qnbMode ? "vertical-spacing-20 radioButtonQnB" : "vertical-spacing-20"
        },
        dayOfMonthRow: {
            visible: showPaymentDayOfMonth()
        },
        dayOfMonth: {
            availableValues: getValidDayOfMonths(),
            onValueChange: onDayOfMonthChange,            
            value: getdayOfMonth(),
            required:showPaymentDayOfMonth()
        },
        emailNoticeRow: {
            visible: showEmailReminder()
        },
        emailNotice: {
            label: getEmailReminderText(),
            onValueChange: onEmailNoticeChange,
            className: qnbMode ? "radioButtonQnB" : ""
        },
        mlScriptComponent: {
            mlScript: scriptML,
            visible: showScript()
        },
        scriptCheckboxField: {
            value: isChecked,
            visible: showScript() && showCheckbox(),
            onValueChange: updateCheckboxValue
        },
        preferredPaymentMethodIndContainer: {
            visible: isPreferredPaymentVisible() && !isPersonalUmbrella
        },
        preferredPaymentMethodIndInput: {
            onValueChange: selectPreferredPaymentMethodInd,
            controlClassName: qnbMode ? "radio-button-qs horizontal-space-5 radioButtonQnB radioButtonPE" : "radio-button-qs horizontal-space-5 radioButtonPE"
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={paymentDetails}
            onValidationChange={setComponentValidation}
            showErrors={showValidationErrors}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

MLPaymentScheduleComponent.propTypes = {
    id: PropTypes.string.isRequired,
    onValidate: PropTypes.func.isRequired,
    showValidationErrors: PropTypes.bool.isRequired,
    paymentDetails: PropTypes.shape({
        paymentPlans_ML: PropTypes.shape({
            value: PropTypes.shape({
                code: PropTypes.string
            })
        }),
        ratingPaymentMethod_ML: PropTypes.shape({
            aspects: PropTypes.shape({
                availableValues: PropTypes.arrayOf(PropTypes.shape({}))
            }),
            value: PropTypes.shape({
                code: PropTypes.string
            })
        }),
        downPaymentOverride_ML: PropTypes.shape({
            value: PropTypes.bool
        }),
        selectedPaymentPlan_ML: PropTypes.shape({
            value: PropTypes.string
        }),
        paymentDayOfMonth_ML: PropTypes.shape({
            value: PropTypes.number
        }),
        paymentMethod: PropTypes.shape({
            value: PropTypes.string
        }),
        preferEmailNotice_ML: PropTypes.shape({
            value: PropTypes.bool
        }),
    }).isRequired,
    offeredQuotes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    chosenQuote: PropTypes.shape({
        value: PropTypes.string
    }).isRequired,
    termType: PropTypes.string.isRequired,
    gpaMode: PropTypes.bool.isRequired,
    isEndorsement: PropTypes.bool,
    selectPaymentPlan: PropTypes.func.isRequired,
    isPaymentScriptChecked: PropTypes.bool
};

MLPaymentScheduleComponent.defaultProps = {
    isEndorsement: false,
    isPaymentScriptChecked: _.noop
};

export default MLPaymentScheduleComponent;
